import API from "./API";
import axios from "axios";

export const DPC = {

    async getActions(){
        const url = API.url('/dpc/actions');
        return await axios.get(url);
    }, 

    async getAction(id){
        const url = API.url('/dpc/actions/' + id);
        return await axios.get(url);
    },

    async postAction(data){
        const url = API.url('/dpc/actions');
        return await axios.post(url, data);
    },

    async putAction(data){
        const url = API.url('/dpc/actions/' + data.id);
        return await axios.put(url, data);
    },

    async deleteAction(id){
        const url = API.url('/dpc/actions/' + id);
        return await axios.delete(url);
    },

    async getActionSessions(id){
        const url = API.url('/dpc/actions/' + id + '/sessions');
        return await axios.get(url);
    },

    async getSession(id){
        const url = API.url('/dpc/sessions/' + id);
        return await axios.get(url);
    },

    async postSession(data){
        const url = API.url('/dpc/sessions');
        return await axios.post(url, data);
    },

    async putSession(data){
        const url = API.url('/dpc/sessions/' + data.id);
        console.log(data)
        return await axios.put(url, data);
    },

    async deleteSession(id){
        const url = API.url('/dpc/sessions/' + id);
        return await axios.delete(url);
    },

    async getSessionRegistrations(id){
        const url = API.url('/dpc/sessions/' + id + '/registrations');
        return await axios.get(url);
    }, 

    async toggleRegistration(data){
        const url = API.url(`/dpc/registrations/${data.id}/cancel`);
        return await axios.get(url);
    },

    async getCourse(id){
        const url = API.url('/dpc/courses/' + id);
        return await axios.get(url);
    },

    async getPiCourses(){
        const url = API.url('/dpc/pi/courses');
        return await axios.get(url);
    },

    async fetchRegistration(actionRef, rpps){
        const syncUrl = API.url(`/dpc/sync`);
        await axios.get(syncUrl);

        const url = API.url(`/dpc/fetch/${actionRef}/${rpps}`);
        return await axios.get(url);
    },

    async getOrphans(){
        const url = API.url('/dpc/orphans');
        return await axios.get(url);
    },

    participationUrl(id){
        return API.url(`/dpc/registrations/${id}/participation`);
    },

    async getParticipation(id){
        const url = this.participationUrl(id);
        return await axios.get(url);
    },

    async postParticipation(id, file){
        const url = API.url(`/dpc/registrations/${id}/participation`);
        const data = new FormData();
        data.append('file', file);
        return await axios.post(url, data, {headers: {'Content-Type': 'multipart/form-data'}});
    },

}

export default DPC;